import { NavBarHeader } from "components/shared/Header";
import { Outlet } from "react-router-dom";
import { styled } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useCollapseDrawer from "hooks/useCollapseDrawer";
import Sidebar from "components/shared/Sidebar";
import { useState } from "react";
import GenerateReports from "components/Dialog/GenerateReports";
import { WithValidRoles } from "components/hoc/wrapper/WithValidRoles";

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 70;

const MainStyle = styled("div")(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  minHeight: "100%",
  paddingTop: APP_BAR_MOBILE + 10,
  paddingBottom: 0,
  paddingLeft: 10,
  paddingRight: 10,
  [theme.breakpoints.up("lg")]: {
    paddingTop: APP_BAR_DESKTOP + 20,
    paddingLeft: 20,
    paddingRight: 20,
  },
}));

export function DashboardLayout() {
  const theme = useTheme();
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);

  return (
    // <WithSignin>
    <WithValidRoles>
      {/*<Header />*/}
      <GenerateReports />
      <div className="flex overflow-hidden min-h-full">
        <NavBarHeader onOpenSidebar={() => setOpen(true)} />
        <Sidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
        <MainStyle
          sx={{
            transition: theme.transitions.create("margin", {
              duration: theme.transitions.duration.complex,
            }),
            background: `url(/assets/images/background/background.png)`,
            backgroundSize: "cover",
            ...(collapseClick && {
              ml: "102px",
            }),
          }}
        >
          <Outlet />
        </MainStyle>
      </div>
    </WithValidRoles>
    // </WithSignin>
  );
}
